import React,{useEffect} from 'react'
// import GoogleLogin from 'react-google-login'
import {json, useNavigate} from 'react-router-dom'
import {FcGoogle} from 'react-icons/fc'
import Logo from '../assets/logo.jpeg'
import Video from '../assets/Video/bg.mp4'
import { GoogleLogin } from '@react-oauth/google';
import {useGoogleLogin} from '@react-oauth/google';
import jwt_decode from "jwt-decode";
import axios from 'axios'
import {client} from '../client'
function Login() {
  const navigate = useNavigate();
const responseGoogle = (response) => {
  console.log(response)
  // localStorage.setItem('user', JSON.stringify(response.profileObj));
  // const { name, googleId, imageUrl } = response.profileObj;
  // const doc = {
  //   _id: googleId,
  //   _type: 'user',
  //   userName: name,
  //   image: imageUrl,
  // };
  // client.createIfNotExists(doc).then(() => {
  //   navigate('/', { replace: true });
  // });
};


const login = useGoogleLogin({
  onSuccess: async respose => {
      try {
          const res = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
              headers: {
                  "Authorization": `Bearer ${respose.access_token}`
              }
          })
console.log(res)
          console.log(res.data)
      } catch (err) {
          console.log(err)

      }

  }
});

  return (
  <div className="flex jusitify-start items-center flex-col h-screen">
    <div className='relative w-full h-full'>
   {/* <video src={Video} type='video/mp4' controls={false} muted loop autoPlay
   className='w-full h-full object-cover'
   />   */}
   <div className='absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0    bg-blackOverlay'>
    <div className="p-5">
   <span><img src={Logo} width="60px"  alt='LOGO'/>  
  <span className='text-blue-800 text-lg font-bold'>MY SWEET MEMORIES</span>
   </span>
   {/* <button onClick={login} 
      className="bg-mainColor flex justify-center items-center p-3 rounded-lg cursor-pointer outline-none">
       <FcGoogle className="mr-4" /> Sign in with google
      </button> */}
      <GoogleLogin
          onSuccess={credentialResponse => {
          console.log(credentialResponse.credential);
          var decoded = jwt_decode(credentialResponse.credential);
          console.log(decoded)
          localStorage.setItem('itemData',JSON.stringify(decoded))
          const {picture,sub,name} = decoded
        const doc = {
          _id:sub,
          _type:'user',
          userName:name,
          image:picture
        }
        client.createIfNotExists(doc).then(() => {
          console.log('user created');
          navigate('/', { replace: true });
        });
        console.log(doc)
      }}
          onError={() => {
          console.log('Login Failed');
      }}/>
  </div>
   </div>

    </div>
</div>
  )
}

export default Login